export default {
  cancel: 'Anuluj',
  circle_config: 'Konfiguracja okręgu',
  confirm: 'Potwierdź',
  confirm_delete: 'Czy na pewno chcesz usunąć tę cechę? Nie można tego cofnąć.',
  create: 'Utwórz',
  dark_mode: 'Kolorystyka',
  delete: 'Usuń',
  delete_geometry: 'Usuń geometrię',
  delete_vertex: 'Usuń wierzchołek',
  document_upload_failed: 'Wysyłanie dokumentu nie powiodło się.',
  draw_circle: 'Okrąg z centrum',
  draw_circle_2pt: 'Okrąg ręczny',
  draw_dialog_begin_drawing:
    'Rozpocznij rysowanie - Kliknij gdziekolwiek na mapie',
  draw_dialog_cancel_drawing: 'Anuluj rysowanie - Klawisz ESC',
  draw_dialog_remove_vertex:
    'Usuń ostatni wierzchołek - Kliknij prawym przyciskiem myszy',
  draw_dialog_save: 'Zapisz - Podwójne kliknięcie',
  draw_dialog_save_single: 'Zapisz - Pojedyncze kliknięcie',
  draw_dialog_title: 'Instrukcje rysowania',
  draw_line: 'Linia',
  draw_point: 'Punkt',
  draw_polygon: 'Wielokąt',
  draw_position: 'Bieżąca pozycja',
  draw_rectangle: 'Prostokąt',
  edit_dialog_cancel_drawing:
    'Anuluj rysowanie - Kliknij przycisk anulowania, aby anulować rysowanie.',
  edit_dialog_modify_shape:
    'Edytuj kształt - Przeciągnij wierzchołek, aby zmodyfikować kształt lub dodaj nowy wierzchołek do wielokąta.',
  edit_dialog_remove_vertex:
    'Usuń wierzchołek - Kliknij na wierzchołek, aby go usunąć.',
  edit_dialog_save: 'Zapisz - Kliknij przycisk zapisu, aby zapisać zmiany.',
  edit_dialog_title: 'Instrukcje edycji',
  filter_searchbox_placeholder: 'Szukaj',
  icon_scaling_cluster: 'Skala ikony grupy',
  icon_scaling_cluster_log: 'Skala logarytmiczna grupy',
  icon_scaling_field: 'Przełącz skalowanie ikon pola',
  icon_scaling_label: 'Skala ikony',
  icon_scaling_zoom_in: 'Skala powiększenia',
  icon_scaling_zoom_out: 'Skala pomniejszenia',
  identical_values_filter:
    'To pole zawiera tylko jedną unikalną wartość i nie można go filtrować.',
  image_upload_failed: 'Wysyłanie obrazu nie powiodło się.',
  information: 'Informacje',
  invalid_geometry: 'Nieprawidłowa geometria',
  invalid_lat_lon:
    'Podane współrzędne nie mieszczą się w wybranej lokalizacji.',
  invalid_lat_long_range:
    'Nieprawidłowe współrzędne: Wartości szerokości i długości geograficznej muszą mieścić się w dozwolonych zakresach.',
  layer_add_new_location: 'Dodaj nowe lokalizacje',
  layer_dataview_header: 'Widoki danych',
  layer_filter_clear_all: 'Wyczyść wszystkie filtry',
  layer_filter_dropdown_select: 'Wybierz wiele',
  layer_filter_greater_than: 'Większe niż',
  layer_filter_header: 'Filtr',
  layer_filter_less_than: 'Mniejsze niż',
  layer_filter_reset_all: 'Zresetuj wszystkie filtry',
  layer_filter_select: 'Wybierz filtr z listy',
  layer_filter_set_filter: 'Ustaw filtr',
  layer_grid_legend_ratio: 'Wyświetl kolor jako stosunek do rozmiaru',
  layer_group_hide_layers: 'Ukryj wszystkie warstwy w grupie',
  layer_style_cluster: 'Wiele lokalizacji',
  layer_style_display_hover: 'Włącz podświetlenie',
  layer_style_display_labels: 'Wyświetl etykiety',
  layer_style_header: 'Styl',
  layer_style_opacity: 'Zmień przezroczystość warstwy:',
  layer_style_select_theme: 'Wybierz styl tematyczny',
  layer_style_switch_all: 'przełącz wszystko',
  layer_style_switch_caption:
    'Kliknij na etykiety, aby przełączyć widoczność lub',
  layer_visibility: 'Przełącz widoczność',
  layer_zoom_to_extent: 'Powiększ do obszaru filtrowanej warstwy',
  layers: 'Warstwy',
  link: 'Link',
  loading: 'Ładowanie',
  location_clear_all: 'Wyczyść lokalizacje',
  location_close_without_save: 'Zamknąć lokalizację bez zapisywania zmian?',
  location_delete: 'Usuń lokalizację',
  location_listview_full: 'Widok listy dla lokalizacji jest pełny.',
  location_remove: 'Usuń cechę z wyboru',
  location_save: 'Zapisz zmiany w chmurze',
  location_save_changes: 'Czy chcesz zapisać zmiany w tej lokalizacji?',
  location_zoom: 'Powiększ mapę do granic cechy',
  locations: 'Lokalizacje',
  modify_geometry: 'Zmień geometrię',
  no_data_filter: 'To pole nie zawiera danych i nie można go filtrować.',
  no_layers: 'Brak dostępnych warstw w lokalizacji.',
  no_locales:
    'Twoje konto zostało zweryfikowane i zatwierdzone, ale nie masz dostępu do żadnych lokalizacji. Prawdopodobnie jest to spowodowane tym, że administrator nie przyznał Ci wymaganych ról. Skontaktuj się z administratorem, aby rozwiązać ten problem.',
  no_options_available: 'Brak dostępnych opcji.',
  no_results: 'Brak wyników dla tego wyszukiwania',
  ok: 'OK',
  pill_component_remove: 'Usuń',
  pin: 'Przypnij',
  radius: 'Promień',
  remove_document_confirm:
    'Czy na pewno chcesz usunąć ten dokument? Nie można tego cofnąć.',
  remove_image_confirm:
    'Czy na pewno chcesz usunąć obraz? Nie można tego cofnąć.',
  remove_item_confirm: 'Usuń element?',
  remove_last_vertex: 'Usuń ostatni wierzchołek',
  report: 'Raport',
  save: 'Zapisz',
  toolbar_admin: 'Otwórz widok administracyjny konta',
  toolbar_current_location: 'Bieżąca lokalizacja',
  toolbar_fullscreen: 'Pełny ekran mapy',
  toolbar_login: 'Zaloguj się',
  toolbar_logout: 'Wyloguj się',
  toolbar_zoom_in: 'Powiększ',
  toolbar_zoom_out: 'Pomniejsz',
  toolbar_zoom_to_area: 'Powiększ do obszaru',
  units: 'Jednostki',
  zoom_to: 'Powiększ do',
};
